import React from 'react'

const PaymentIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_2791_62109"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2791_62109)">
        <path
          d="M14 13C14.8333 13 15.5417 12.7083 16.125 12.125C16.7083 11.5417 17 10.8333 17 10C17 9.16667 16.7083 8.45833 16.125 7.875C15.5417 7.29167 14.8333 7 14 7C13.1667 7 12.4583 7.29167 11.875 7.875C11.2917 8.45833 11 9.16667 11 10C11 10.8333 11.2917 11.5417 11.875 12.125C12.4583 12.7083 13.1667 13 14 13ZM7 16C6.45 16 5.97933 15.804 5.588 15.412C5.196 15.0207 5 14.55 5 14V6C5 5.45 5.196 4.97933 5.588 4.588C5.97933 4.196 6.45 4 7 4H21C21.55 4 22.021 4.196 22.413 4.588C22.8043 4.97933 23 5.45 23 6V14C23 14.55 22.8043 15.0207 22.413 15.412C22.021 15.804 21.55 16 21 16H7ZM3 20C2.45 20 1.97933 19.8043 1.588 19.413C1.196 19.021 1 18.55 1 18V8C1 7.71667 1.096 7.479 1.288 7.287C1.47933 7.09567 1.71667 7 2 7C2.28333 7 2.521 7.09567 2.713 7.287C2.90433 7.479 3 7.71667 3 8V18H19C19.2833 18 19.5207 18.096 19.712 18.288C19.904 18.4793 20 18.7167 20 19C20 19.2833 19.904 19.5207 19.712 19.712C19.5207 19.904 19.2833 20 19 20H3ZM7 8C7.55 8 8.02067 7.804 8.412 7.412C8.804 7.02067 9 6.55 9 6H7V8ZM21 8V6H19C19 6.55 19.1957 7.02067 19.587 7.412C19.979 7.804 20.45 8 21 8ZM7 14H9C9 13.45 8.804 12.979 8.412 12.587C8.02067 12.1957 7.55 12 7 12V14ZM19 14H21V12C20.45 12 19.979 12.1957 19.587 12.587C19.1957 12.979 19 13.45 19 14Z"
          fill="#999FAC"
        />
      </g>
    </svg>
  )
}

export default PaymentIcon
